import React from "react";
import Spinner from "@atlaskit/spinner";

export default function AtkLoader(props: any) {
  return <Spinner appearance="inherit" size="medium" />;
}
